import {EvkHttpService, EvkOption, EvkResponseType} from "@evomatik/evk-common";
import {Injectable} from "@angular/core";
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class ExpedienteUpdateEstatusService {

    constructor(
        public http: EvkHttpService
    ) {
    }

    public notificarAlAreaDeAnalisis(id) {
        return this.http.put<EvkResponseType<EvkOption[]>>(`/seaged-expedientes-service/estado/notificar-area-analisis/${id}`, {}).pipe(
            map(response => response.data)
        );
    }

    public notificarAlAreaDeBusqueda(id) {
        return this.http.put<EvkResponseType<EvkOption[]>>(`/seaged-expedientes-service/estado/notificar-area-busqueda/${id}`, {}).pipe(
            map(response => response.data)
        );
    }
}
